// eslint-disable-next-line import/prefer-default-export
export enum DockyardStatus {
  IN_PROGRESS = "in_progress",
  DONE = "done",
}
